import Vue from 'vue'
import Vuex from 'vuex'
import demos from './demos'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        demos,
    },
    state: {
        logo: 'https://cell-0.com/img/cell-0-logo-small.png',
        accentColor: '#f05931',
        backgroundColor: '#31b69c',
        darkTheme: true,
    },
    getters: {
        logo (state) {
            return state.logo
        },
        backgroundColor (state) {
            return state.backgroundColor
        },
        accentColor (state) {
            return state.accentColor
        },
        darkTheme (state) {
            return state.darkTheme
        },
        lightTheme (state) {
            return !state.darkTheme
        },
    },
    mutations: {
        logoUpdated (state, src) {
            state.logo = src
        },
        backgroundColorUpdated (state, color) {
            state.backgroundColor = color
        },
        accentColorUpdated (state, color) {
            state.accentColor = color
        },
        setDarkTheme (state, isDarkTheme) {
            state.darkTheme = isDarkTheme
        },
    },
})
